/**
 * Is `value` an object path rather than a URL? Anything with a scheme or protocol-relative is
 * external; blank is not a path. Deliberately does not check the `assignment_templates/` prefix —
 * that is the backend's job, and dropping such a path here would lose it from the manifest.
 */
export const isAssignmentMediaPath = (value: string): boolean => {
  const trimmed = value.trim()
  if (!trimmed) return false

  return !/^(?:[a-z][a-z\d+\-.]*:|\/\/)/i.test(trimmed)
}
